<template>
  <div class="products">
    <div class="container">
      <div class="intro h-100">
        <div class="row h-100">
          <div class="col-md-12">
            <div v-if="orden != null">
              <div class="desc">
                <h3>Datos del Cliente</h3>
                <h6>Nombre:</h6>
                <p>{{orden.datos.name}}</p>
                <h6>Email:</h6>
                <p>{{orden.datos.email}}</p>
                <h6>Proyecto:</h6>
                <p>{{orden.datos.proyecto}}</p>
                <p style="font-weight: 300;">
                  <b>Información solicitada:</b>
                  {{orden.datos.message}}
                </p>
              </div>
              <div class="productslist">
                <div class="productslist-center">
                  <div v-for="item in orden.productos">
                    <div class="product">
                      <div class="img-container">
                        <img :src="item.productImage" alt />
                      </div>

                      <div class="product-info">
                        <h6 class>Código: {{item.productTag.slice(0, -1) }}</h6>
                        <h5 class="card-title">{{ item.productName }}</h5>
                        <h5 class="card-title">A cotizar: {{ item.productQuantity }}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div class="product-test">
        <h3 class="d-inline-block">Ordenes Cotizadas</h3>

        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Email</th>
                <th>Descripcion</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="order in orders">
                <td>{{order.datos.name}}</td>

                <td>{{order.datos.email}}</td>
                <td>{{order.datos.message}}</td>

                <td class="text-center">
                  <span v-if="order.datos.activa" style="color: orange;">
                    <i class="fa fa-circle"></i>
                  </span>
                  <span v-else style="color: green;">
                    <i class="fa fa-circle"></i>
                  </span>
                </td>

                <td>
                  <button
                    v-if="order.datos.activa"
                    class="btn btn-warning btn-sm mr-1 ml-1"
                    @click="editProduct(order)"
                  >Activa</button>
                  <button
                    v-else
                    class="btn btn-success btn-sm mr-1 ml-1"
                    @click="editProduct(order)"
                  >Cotizada</button>
                  <button class="btn btn-info btn-sm" @click="seleccionado(order)">Detalles</button>
                  <button class="btn btn-danger btn-sm ml-1" @click="deleteProduct(order)">Eliminar</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { fb, db } from "../firebase";

export default {
  name: "Orders",
  components: {
    VueEditor
  },
  props: {
    msg: String
  },

  data() {
    return {
      orders: [],
      orden: null,
      products: []
    };
  },

  firestore() {
    return {
      orders: db.collection("orders"),
      products: db.collection("products")
    };
  },
  computed: {
    activas() {
      return this.orders.filter(order => {
        return order.datos.activa === 1;
      });
      console.log(activas);
    }
  },
  methods: {
    deleteImage(img, index) {
      let image = fb.storage().refFromURL(img);

      this.product.images.splice(index, 1);

      image
        .delete()
        .then(function() {
          console.log("image deleted");
        })
        .catch(function(error) {
          // Uh-oh, an error occurred!
          console.log("an error occurred");
        });
    },
    ordenCargar() {
      return (this.orden = this.orders[0]);
    },

    editProduct(order) {
      order.datos.activa = !order.datos.activa;
    },
    seleccionado(order) {
      this.orden = order;
      console.log(this.orden);
    },

    deleteProduct(doc) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$firestore.orders.doc(doc.id).delete();

          Toast.fire({
            type: "success",
            title: "Deleted  successfully"
          });
        }
      });
    },
    readData() {}
  },
  created() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
body {
  background: lightgray !important;
}

.img-wrapp {
  position: relative;
}
.img-wrapp span.delete-img {
  position: absolute;
  top: -14px;
  left: -2px;
}
.img-wrapp span.delete-img:hover {
  cursor: pointer;
}

.products {
  margin-top: 1rem;
  background: #ebebeb;
  padding-bottom: 3rem;
}
.productslist {
  padding: 5rem 0;
}
.productslist-center {
  width: 80vw;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  grid-row-gap: 2rem;
  grid-column-gap: 30px;
}

@media screen and (min-width: 776px) {
  .productslist-center {
    width: 90vw;
  }
}
@media screen and (min-width: 992px) {
  .productslist-center {
    width: 95vw;
    max-width: 1170px;
  }
}

/* product */
.product {
  box-shadow: var(--lightShadow);
  transition: var(--mainTransition);
}
.product:hover {
  box-shadow: var(--darkShadow);
}

.img-container {
  position: relative;
}
.img-container img {
  width: 100%;
  display: block;
  transition: var(--mainTransition);
}
.price-top {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  color: var(--mainWhite);
  padding: 0.3rem 0.6rem 0.5rem;
  border-bottom-right-radius: 1rem;
  font-size: 0.5rem;
  text-align: center;
  transition: var(--mainTransition);
}
.price-top h6 {
  margin-bottom: 0;
  font-size: 0.9rem;
  font-weight: 300;
  letter-spacing: var(--mainSpacing);
}
.product-link {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: scale(0);
  transition: all 0.3s linear;
}
.img-container:hover {
  background: rgba(0, 0, 0, 0.8);
}
.img-container:hover img {
  opacity: 0.3;
}
.img-container:hover .price-top {
  opacity: 0;
}
.img-container:hover .product-link {
  transform: translate(-50%, -50%) scale(1);
}
.product-info {
  background: var(--darkGrey);
  text-transform: capitalize;
  padding: 0.5rem 0;
  text-align: center;
  font-weight: 700;

  letter-spacing: var(--mainSpacing);
}
/* end of product  */

.section-title {
  text-align: center;
  margin-bottom: 4rem;
}
.section-title h4 {
  font-size: 2rem;
  letter-spacing: var(--mainSpacing);
  text-transform: capitalize;
  margin-bottom: 1rem;
}
.section-title div {
  width: 18rem;
  height: 5px;
  margin: 0 auto;
  background: var(--primaryColor);
}
</style>
